/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit-element';

/**
 * Option_2 CSS
 */
export const styles = css`


:host {
    display: block;
    user-select: none;
  }

  :host(:focus) {
    outline: none;
  }

  .option {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: 400;
    line-height:  1.8;
    letter-spacing: normal;
    color: hsl(240 5.3% 26.1%);;
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    transition: 150ms fill;
    cursor: pointer;
  }

  .option--hover:not(.option--current):not(.option--disabled) {
    background-color: hsl(240 4.8% 95.9%);
    color: hsl(0, 0%, 0%);
  }

  .option--current,
  .option--current.option--disabled {
    background-color: hsl(200.4 98% 39.4%);
    color: hsl(0, 0%, 100%);
    opacity: 1;
  }

  .option--disabled {
    outline: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  .option__label {
    flex: 1 1 auto;
    display: inline-block;
    line-height: 1.4;
  }

  .option .option__check {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
    padding-inline-end: 0.25rem;
  }

  .option--selected .option__check {
    visibility: visible;
  }

  .option__prefix,
  .option__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .option__prefix::slotted(*) {
    margin-inline-end: 0.5rem;
  }

  .option__suffix::slotted(*) {
    margin-inline-start: 0.5rem;
  }

  @media (forced-colors: active) {
    :host(:hover:not([aria-disabled='true'])) .option {
      outline: dashed 1px SelectedItem;
      outline-offset: -1px;
    }
  }
`;



export default [styles];
